import React, { useRef, useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { 
  Compass, 
  Plane, 
  Ship, 
  Truck, 
  Warehouse, 
  FileCheck, 
  Shield,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

const otherServicesData = {
  pt: [
    { 
      id: 1, 
      title: 'Consultoria em Comércio Exterior', 
      icon: Compass,
      description: 'Está enfrentando dificuldades para entender os processos do comércio exterior de ponta a ponta? A Well Cargo oferece assessoria personalizada em logística internacional, atuando lado a lado com sua empresa para assegurar clareza, segurança e eficiência nas operações.',
      details: 'Apoiamos nossos clientes na estruturação de projetos de importação e exportação, realizando estudos de viabilidade, análises estratégicas e planos de negócio sob medida, sempre alinhados à realidade e aos objetivos da sua empresa.\n\nMais do que assessorar, nós traduzimos a complexidade do comércio exterior em soluções práticas, seguras e adaptáveis, ajudando você a tomar decisões com confiança em cada etapa da jornada internacional.'
    },
    { 
      id: 2, 
      title: 'Transporte Aéreo', 
      icon: Plane,
      description: 'A Well Cargo é parceira das principais companhias aéreas do mercado, oferecendo soluções ágeis e seguras para importações e exportações com embarques para os principais aeroportos internacionais do mundo.',
      details: 'Além do transporte, contamos com uma estrutura logística completa, incluindo serviços de consolidação de cargas e armazenamento em warehouses parceiras estrategicamente localizadas, garantindo maior eficiência, controle e otimização de custos.\n\nSeja para cargas urgentes, sensíveis, de alto valor, perigosas, perecíveis ou com controle de temperatura, nossa equipe atua com precisão e acompanhamento próximo, proporcionando uma operação aérea com fluidez e total previsibilidade.'
    },
    { 
      id: 3, 
      title: 'Transporte Marítimo', 
      icon: Ship,
      description: 'A Well Cargo possui parceria com os principais armadores e agentes internacionais, oferecendo soluções completas e personalizadas para o transporte marítimo de importação e exportação.',
      details: 'Nosso know-how aliado a uma rede global qualificada nos permite atender com excelência os mais diversos tipos de operação, garantindo segurança, previsibilidade e suporte dedicado em todas as etapas do processo.\n\nEstamos preparados para atuar com diferentes modalidades de transporte de carga, incluindo:\n• LCL (carga consolidada)\n• FCL (full contêiner)\n• Break Bulk\n• Cargas Projeto\n• Cargas Ro-Ro (Roll-on/Roll-off)\n\nCom a Well Cargo, sua carga marítima navega com eficiência e confiança, de ponta a ponta.'
    },
    { 
      id: 4, 
      title: 'Transporte Rodoviário', 
      icon: Truck,
      description: 'A Well Cargo oferece soluções rodoviárias com agilidade, segurança e alto padrão de qualidade, conectando portos, aeroportos, armazéns e plantas industriais em todo o território nacional e internacional.',
      details: 'Atuamos com uma ampla gama de serviços terrestres, incluindo:\n• Transporte de contêineres\n• Cargas consolidadas (LTL)\n• Cargas perigosas\n• Cargas projeto\n• Cargas em regime de DTA e MIC-DTA\n\nCom uma rede de transportadoras parceiras e rígido controle operacional, atuamos para assegurar o cumprimento de prazos, a rastreabilidade e o suporte dedicado em cada etapa da movimentação.\n\nConte com a Well Cargo para um transporte terrestre eficiente, confiável e alinhado às exigências do comércio exterior.'
    },
    { 
      id: 5, 
      title: 'Warehousing & Logística Integrada', 
      icon: Warehouse,
      description: 'Na Well Cargo, nossos serviços vão além do transporte. Contamos com uma rede global de warehouses parceiros, estrategicamente posicionados para oferecer soluções completas de armazenagem e logística integrada.',
      details: 'Oferecemos suporte nas principais etapas logísticas, incluindo:\n• Armazenagem temporária ou de longo prazo\n• Etiquetagem e repacking\n• Pesagem e inspeção\n• Consolidação e desconsolidação de cargas\n• Estufagem e desova de contêineres\n\nEsses serviços complementares nos permitem otimizar a sua cadeia logística, reduzir custos e preparar a carga de forma estratégica para os embarques internacionais.\n\nCom a Well Cargo, você tem estrutura, controle e eficiência, onde sua carga estiver.'
    },
    { 
      id: 6, 
      title: 'Desembaraço Aduaneiro', 
      icon: FileCheck,
      description: 'A Well Cargo possui uma estrutura especializada em regulamentações aduaneiras e processos alfandegários no Brasil e em diversos países, garantindo que suas operações ocorram com eficácia, conformidade e agilidade.',
      details: 'Nossa equipe técnica atua de forma estratégica para assegurar a liberação rápida e segura das cargas, minimizando riscos, evitando atrasos e assegurando total aderência às exigências legais de cada país.\n\nCom conhecimento profundo da legislação e experiência em diferentes regimes aduaneiros, oferecemos suporte completo em:\n• Importações e exportações\n• Regimes especiais\n• Classificação fiscal e compliance documental\n• Intervenções com órgãos anuentes\n• Catálogo de produtos\n\nNa Well Cargo, o desembaraço não é apenas uma etapa do processo — é uma vantagem competitiva.'
    },
    { 
      id: 7, 
      title: 'Seguro Internacional', 
      icon: Shield,
      description: 'Na Well Cargo, a segurança da sua carga é prioridade. Por isso, oferecemos seguros internacionais com cobertura ampla e personalizada, garantindo tranquilidade durante todo o trajeto, seja por via aérea, marítima ou terrestre.',
      details: 'Nossos seguros abrangem diferentes tipos de mercadorias e operações, tanto de importação quanto exportação, protegendo sua carga contra perdas, avarias, roubo e demais riscos logísticos.\n\nCom o suporte da nossa equipe, você conta com:\n• Análise do perfil da carga e recomendação da melhor cobertura\n• Acompanhamento da apólice do início ao fim da operação\n• Atuação rápida em casos de sinistro\n\nGaranta proteção total para suas operações com o seguro certo e o parceiro certo: a Well Cargo.'
    },
  ],
  en: [
    { 
      id: 1, 
      title: 'Foreign Trade Consulting', 
      icon: Compass,
      description: 'Are you facing difficulties understanding foreign trade processes from end to end? Well Cargo offers personalized consulting in international logistics, working alongside your company to ensure clarity, security and efficiency in operations.',
      details: 'We support our clients in structuring import and export projects, conducting feasibility studies, strategic analyses and customized business plans, always aligned with your company\'s reality and objectives.\n\nMore than advising, we translate the complexity of foreign trade into practical, safe and adaptable solutions, helping you make decisions with confidence at every stage of the international journey.'
    },
    { 
      id: 2, 
      title: 'Air Transport', 
      icon: Plane,
      description: 'Well Cargo is a partner of the main airlines in the market, offering agile and secure solutions for imports and exports with shipments to the main international airports in the world.',
      details: 'In addition to transport, we have a complete logistics structure, including cargo consolidation services and storage in strategically located partner warehouses, ensuring greater efficiency, control and cost optimization.\n\nWhether for urgent, sensitive, high-value, dangerous, perishable cargo or with temperature control, our team acts with precision and close monitoring, providing an air operation with fluidity and total predictability.'
    },
    { 
      id: 3, 
      title: 'Sea Transport', 
      icon: Ship,
      description: 'Well Cargo has partnerships with the main shipowners and international agents, offering complete and personalized solutions for maritime import and export transport.',
      details: 'Our know-how combined with a qualified global network allows us to serve with excellence the most diverse types of operations, ensuring security, predictability and dedicated support at all stages of the process.\n\nWe are prepared to work with different cargo transport modalities, including:\n• LCL (consolidated cargo)\n• FCL (full container)\n• Break Bulk\n• Project Cargo\n• Ro-Ro Cargo (Roll-on/Roll-off)\n\nWith Well Cargo, your maritime cargo sails with efficiency and confidence, from end to end.'
    },
    { 
      id: 4, 
      title: 'Road Transport', 
      icon: Truck,
      description: 'Well Cargo offers road solutions with agility, security and high quality standards, connecting ports, airports, warehouses and industrial plants throughout national and international territory.',
      details: 'We work with a wide range of land services, including:\n• Container transport\n• Consolidated cargo (LTL)\n• Dangerous cargo\n• Project cargo\n• Cargo under DTA and MIC-DTA regime\n\nWith a network of partner carriers and strict operational control, we work to ensure compliance with deadlines, traceability and dedicated support at every stage of movement.\n\nCount on Well Cargo for efficient, reliable road transport aligned with foreign trade requirements.'
    },
    { 
      id: 5, 
      title: 'Warehousing & Integrated Logistics', 
      icon: Warehouse,
      description: 'At Well Cargo, our services go beyond transport. We have a global network of partner warehouses, strategically positioned to offer complete storage and integrated logistics solutions.',
      details: 'We offer support in the main logistics stages, including:\n• Temporary or long-term storage\n• Labeling and repacking\n• Weighing and inspection\n• Cargo consolidation and deconsolidation\n• Container stuffing and unstuffing\n\nThese complementary services allow us to optimize your logistics chain, reduce costs and strategically prepare cargo for international shipments.\n\nWith Well Cargo, you have structure, control and efficiency, wherever your cargo is.'
    },
    { 
      id: 6, 
      title: 'Customs Clearance', 
      icon: FileCheck,
      description: 'Well Cargo has a specialized structure in customs regulations and customs processes in Brazil and several countries, ensuring that your operations occur with effectiveness, compliance and agility.',
      details: 'Our technical team acts strategically to ensure fast and safe cargo release, minimizing risks, avoiding delays and ensuring full adherence to the legal requirements of each country.\n\nWith deep knowledge of legislation and experience in different customs regimes, we offer complete support in:\n• Imports and exports\n• Special regimes\n• Tax classification and documentary compliance\n• Interventions with consenting agencies\n• Product catalog\n\nAt Well Cargo, customs clearance is not just a step in the process — it\'s a competitive advantage.'
    },
    { 
      id: 7, 
      title: 'International Insurance', 
      icon: Shield,
      description: 'At Well Cargo, the security of your cargo is a priority. That\'s why we offer international insurance with broad and personalized coverage, ensuring peace of mind throughout the journey, whether by air, sea or land.',
      details: 'Our insurance covers different types of goods and operations, both import and export, protecting your cargo against losses, damage, theft and other logistics risks.\n\nWith our team\'s support, you have:\n• Cargo profile analysis and best coverage recommendation\n• Policy monitoring from start to finish of the operation\n• Quick action in case of claims\n\nEnsure total protection for your operations with the right insurance and the right partner: Well Cargo.'
    },
  ],
  es: [
    { 
      id: 1, 
      title: 'Consultoría en Comercio Exterior', 
      icon: Compass,
      description: '¿Está enfrentando dificultades para entender los procesos del comercio exterior de principio a fin? Well Cargo ofrece asesoría personalizada en logística internacional, actuando junto a su empresa para asegurar claridad, seguridad y eficiencia en las operaciones.',
      details: 'Apoyamos a nuestros clientes en la estructuración de proyectos de importación y exportación, realizando estudios de viabilidad, análisis estratégicos y planes de negocio a medida, siempre alineados con la realidad y los objetivos de su empresa.\n\nMás que asesorar, traducimos la complejidad del comercio exterior en soluciones prácticas, seguras y adaptables, ayudándole a tomar decisiones con confianza en cada etapa del viaje internacional.'
    },
    { 
      id: 2, 
      title: 'Transporte Aéreo', 
      icon: Plane,
      description: 'Well Cargo es socio de las principales aerolíneas del mercado, ofreciendo soluciones ágiles y seguras para importaciones y exportaciones con embarques a los principales aeropuertos internacionales del mundo.',
      details: 'Además del transporte, contamos con una estructura logística completa, incluyendo servicios de consolidación de cargas y almacenamiento en warehouses asociados estratégicamente ubicados, garantizando mayor eficiencia, control y optimización de costos.\n\nYa sea para cargas urgentes, sensibles, de alto valor, peligrosas, perecederas o con control de temperatura, nuestro equipo actúa con precisión y acompañamiento cercano, proporcionando una operación aérea con fluidez y total previsibilidad.'
    },
    { 
      id: 3, 
      title: 'Transporte Marítimo', 
      icon: Ship,
      description: 'Well Cargo tiene asociación con los principales armadores y agentes internacionales, ofreciendo soluciones completas y personalizadas para el transporte marítimo de importación y exportación.',
      details: 'Nuestro know-how combinado con una red global calificada nos permite atender con excelencia los más diversos tipos de operación, garantizando seguridad, previsibilidad y soporte dedicado en todas las etapas del proceso.\n\nEstamos preparados para actuar con diferentes modalidades de transporte de carga, incluyendo:\n• LCL (carga consolidada)\n• FCL (contenedor completo)\n• Break Bulk\n• Cargas Proyecto\n• Cargas Ro-Ro (Roll-on/Roll-off)\n\nCon Well Cargo, su carga marítima navega con eficiencia y confianza, de punta a punta.'
    },
    { 
      id: 4, 
      title: 'Transporte Terrestre', 
      icon: Truck,
      description: 'Well Cargo ofrece soluciones terrestres con agilidad, seguridad y alto estándar de calidad, conectando puertos, aeropuertos, almacenes y plantas industriales en todo el territorio nacional e internacional.',
      details: 'Actuamos con una amplia gama de servicios terrestres, incluyendo:\n• Transporte de contenedores\n• Cargas consolidadas (LTL)\n• Cargas peligrosas\n• Cargas proyecto\n• Cargas en régimen de DTA y MIC-DTA\n\nCon una red de transportistas asociados y rígido control operacional, actuamos para asegurar el cumplimiento de plazos, la trazabilidad y el soporte dedicado en cada etapa del movimiento.\n\nCuente con Well Cargo para un transporte terrestre eficiente, confiable y alineado con las exigencias del comercio exterior.'
    },
    { 
      id: 5, 
      title: 'Warehousing y Logística Integrada', 
      icon: Warehouse,
      description: 'En Well Cargo, nuestros servicios van más allá del transporte. Contamos con una red global de warehouses asociados, estratégicamente posicionados para ofrecer soluciones completas de almacenaje y logística integrada.',
      details: 'Ofrecemos soporte en las principales etapas logísticas, incluyendo:\n• Almacenaje temporal o de largo plazo\n• Etiquetado y reempaque\n• Pesaje e inspección\n• Consolidación y desconsolidación de cargas\n• Estiba y desestiba de contenedores\n\nEstos servicios complementarios nos permiten optimizar su cadena logística, reducir costos y preparar la carga de forma estratégica para los embarques internacionales.\n\nCon Well Cargo, usted tiene estructura, control y eficiencia, donde esté su carga.'
    },
    { 
      id: 6, 
      title: 'Despacho Aduanero', 
      icon: FileCheck,
      description: 'Well Cargo posee una estructura especializada en regulaciones aduaneras y procesos alfandegarios en Brasil y diversos países, garantizando que sus operaciones ocurran con eficacia, conformidad y agilidad.',
      details: 'Nuestro equipo técnico actúa de forma estratégica para asegurar la liberación rápida y segura de las cargas, minimizando riesgos, evitando retrasos y asegurando total adherencia a las exigencias legales de cada país.\n\nCon conocimiento profundo de la legislación y experiencia en diferentes regímenes aduaneros, ofrecemos soporte completo en:\n• Importaciones y exportaciones\n• Regímenes especiales\n• Clasificación fiscal y compliance documental\n• Intervenciones con órganos anuentes\n• Catálogo de productos\n\nEn Well Cargo, el despacho no es solo una etapa del proceso — es una ventaja competitiva.'
    },
    { 
      id: 7, 
      title: 'Seguro Internacional', 
      icon: Shield,
      description: 'En Well Cargo, la seguridad de su carga es prioridad. Por eso, ofrecemos seguros internacionales con cobertura amplia y personalizada, garantizando tranquilidad durante todo el trayecto, sea por vía aérea, marítima o terrestre.',
      details: 'Nuestros seguros abarcan diferentes tipos de mercancías y operaciones, tanto de importación como exportación, protegiendo su carga contra pérdidas, averías, robo y demás riesgos logísticos.\n\nCon el soporte de nuestro equipo, usted cuenta con:\n• Análisis del perfil de la carga y recomendación de la mejor cobertura\n• Acompañamiento de la póliza del inicio al fin de la operación\n• Actuación rápida en casos de siniestro\n\nGarantice protección total para sus operaciones con el seguro correcto y el socio correcto: Well Cargo.'
    },
  ]
};

const OtherServices = () => {
  const { t, language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [expandedService, setExpandedService] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const toggleExpand = (id) => {
    setExpandedService(expandedService === id ? null : id);
  };

  return (
    <section ref={sectionRef} className="py-16 md:py-24 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className={`text-center mb-12 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
            {t('services.otherTitle')}
          </h2>
        </div>

        {/* Services List */}
        <div className="space-y-4">
          {otherServicesData[language].map((service, index) => {
            const IconComponent = service.icon;
            const isExpanded = expandedService === service.id;
            
            return (
              <div 
                key={service.id} 
                className={`bg-gray-50 dark:bg-gray-800 rounded-2xl overflow-hidden transition-all duration-500 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                {/* Service Header */}
                <div 
                  className="p-6 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  onClick={() => toggleExpand(service.id)}
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#3ECDA3]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <IconComponent className="w-6 h-6 text-[#3ECDA3]" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white">
                          {service.title}
                        </h3>
                        <button className="ml-4 text-[#3ECDA3] hover:text-[#35b892] transition-colors">
                          {isExpanded ? <ChevronUp className="w-6 h-6" /> : <ChevronDown className="w-6 h-6" />}
                        </button>
                      </div>
                      <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed mt-2">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Expanded Content */}
                <div className={`overflow-hidden transition-all duration-500 ${
                  isExpanded ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                }`}>
                  <div className="px-6 pb-6 pt-2 ml-16">
                    <div className="border-l-2 border-[#3ECDA3] pl-4">
                      {service.details.split('\n').map((paragraph, i) => (
                        <p key={i} className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed mb-2">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className={`mt-12 text-center transition-all duration-700 delay-500 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <Link
            to="/contato"
            className="group inline-block bg-[#3ECDA3] text-white px-8 py-4 rounded-full text-sm font-medium hover:bg-[#35b892] hover:shadow-lg hover:shadow-[#3ECDA3]/30 transition-all duration-300"
          >
            <span className="group-hover:mr-2 transition-all duration-300">{t('services.cta')}</span>
            <span className="inline-block opacity-0 group-hover:opacity-100 transform translate-x-[-10px] group-hover:translate-x-0 transition-all duration-300">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OtherServices;
